export const LOGIN_LOADING = "LOGIN_LOADING";
export const LOGIN_SUCCESS = "LOGIN_SUCCESS";
export const LOGIN_ERROR = "LOGIN_ERROR";
export const LOGOUT_USER = "LOGOUT_USER";
export const LOGIN_SETUSUARIO = "LOGIN_SETUSUARIO";

export const LOGINTRAZA_ERROR = "LOGINTRAZA_ERROR";
export const LOGINTRAZA_LOADING = "LOGINTRAZA_LOADING";
export const LOGINTRAZA_SUCCESS = "LOGINTRAZA_SUCCESS";
export const LOGOUTRAZA_USER = "LOGOUTRAZA_USER";

export const TOASTER_HIDE = "TOASTER_HIDE";
export const TOASTER_SHOW = "TOASTER_SHOW";

export const MODAL_HIDE = "MODAL_HIDE"; 
export const MODAL_SHOW = "MODAL_SHOW"; 


export const MODAL_ALERTA_HIDE = "MODAL_ALERTA_HIDE"; 
export const MODAL_ALERTA_SHOW = "MODAL_ALERTA_SHOW"; 

export const SET_MODE = "SET_MODE";

export const JSONCONFIG_SUCCESS = "JSONCONFIG_SUCCESS";

export const TOKEN_VALIDATION = "TOKEN_VALIDATION";
export const TOKEN_VALIDATION_SUCCESS = "TOKEN_VALIDATION_SUCCESS";
export const TOKEN_VALIDATION_FAIL = "TOKEN_VALIDATION_FAIL";

export const VERSION_PUBLICADA_LOADING = "VERSION_PUBLICADA_LOADING";
export const VERSION_PUBLICADA_SUCCESS = "VERSION_PUBLICADA_SUCCESS";
export const VERSION_PUBLICADA_ERROR = "VERSION_PUBLICADA_ERROR";
export const VERSION_PUBLICADA_RESET = "VERSION_PUBLICADA_RESET";

export const RESET_GLOBAL_CONTEXT = "RESET_GLOBAL_CONTEXT";